import { CheckIcon, ClipboardIcon } from "@heroicons/react/24/solid";
import { useRef, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next"; // Adjust the import based on your i18n setup
import InputLabel from "./Input.react";
export const InputCopiable = ({ value, ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const copyToClipboard = () => {
    setCopied(false);
    if (value) navigator.clipboard.writeText(value);
    setCopied(true);
    inputRef.current?.focus();
    inputRef.current?.select();
    toast.success(t("flow.id_control.id_controller.error.success_clipboard"));
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <InputLabel
      onClick={copyToClipboard}
      onClickSuffixIcon={copyToClipboard}
      ref={inputRef}
      suffixIcon={copied ? <CheckIcon /> : <ClipboardIcon />}
      {...props}
      value={value}
      readOnly
    />
  );
};
